import { css } from 'styled-components'

export type CTAStyleProps = {
	colorVal: string
	bgVal: string
}

export const ctaStyles = css<CTAStyleProps>`
	border-radius: 5px;
	align-items: center;
	justify-content: center;
	text-align: center;
	color: ${props => props.theme.colors.primary.val};
	color: ${p => p.colorVal};
	position: relative;
	white-space: nowrap;

	.icon {
		width: 1.4em;
		margin-left: 0.5em;
	}
`

export const normalCtaStyles = css<CTAStyleProps>`
	border: solid 1px;
	background: none;
	background: ${p => p.bgVal};
	border-color: ${props => props.theme.colors.primary.val};
	border-color: ${p => p.colorVal};

	&:disabled {
		color: ${props => props.theme.colors.midNeutral.val} !important;
		border-color: ${props => props.theme.colors.midNeutral.val} !important;
		background: none !important;
	}
`

export const solidCtaStyles = css<CTAStyleProps>`
	background: ${props => props.theme.colors.primary.val};
	background: ${p => p.colorVal};
	color: ${props => props.theme.colors.white.val};
	border: solid 1px;
	border-color: ${props => props.theme.colors.primary.val};
	border-color: ${p => p.colorVal};

	&:disabled {
		color: ${props => props.theme.colors.midNeutral.val} !important;
		border-color: ${props => props.theme.colors.midNeutral.val} !important;
		background: none !important;
	}
`

export const invertedNormalCtaStyles = css<CTAStyleProps>`
	background: none;
	border-color: ${props => props.theme.colors.white.val};
	color: ${props => props.theme.colors.white.val};
`

export const invertedSolidCtaStyles = css<CTAStyleProps>`
	background: ${props => props.theme.colors.white.val};
	color: ${props => props.theme.colors.primary.val};
	color: ${p => p.colorVal};
	border: none;

	&:disabled {
		background: ${props => props.theme.colors.midNeutral.opacity(70).val};
		color: ${props => props.theme.colors.darkNeutral.val};
	}
`

export const noBorderCtaStyles = css<CTAStyleProps>`
	${normalCtaStyles}
	border: none;
`

export const largeCtaStyles = css<CTAStyleProps>`
	padding: 1em 2em;
	font-size: 1.5rem;
	line-height: 1.75rem;
	display: flex;
	width: 100%;
	text-transform: uppercase;
`

export const smallCtaStyles = css<CTAStyleProps>`
	padding: 0.5em 0.5em;
	font-size: 1.333rem;
	line-height: 1.533rem;
	display: inline-flex;
	width: auto;
`
